/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  passwordChangedHeading: {
    id: "ChangePasswordSucceededPageComponent.passwordChangedHeading",
    defaultMessage: "Your password has been changed successfully",
  },
  passwordChangedText: {
    id: "ChangePasswordSucceededPageComponent.passwordChangedText",
    defaultMessage: "Please go back to the login page and use your new password.",
  },
  passwordChangedButton: {
    id: "ChangePasswordSucceededPageComponent.passwordChangedButton",
    defaultMessage: "Go back to login",
  },
});

export default MESSAGES;